var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"tu-ui-icon",attrs:{"aria-hidden":"true"}},[_c('svg',{attrs:{"width":_vm.size,"height":_vm.size,"viewBox":"0 0 256 256","fill":"currentColor"},domProps:{"innerHTML":_vm._s(_vm.paths)}})])}
var staticRenderFns = []

export { render, staticRenderFns }